<template>
  <div>
    <div>
      <header class="template_navbar header menu_fixed">
        <div id="logo">
          <a
            :href="`/${this.$store.state.main.lang}/`"
            title="WeKeep"
          >
            <img
              src="../../assets/img/logo.png"
              width="207"
              height="50"
              alt=""
              class="logo_normal"
            >
            <img
              src="../../assets/img/logo_sticky.png"
              width="145"
              height="35"
              alt=""
              class="logo_sticky"
            >
          </a>
        </div>

        <Cookies />
        <NavBarComponents
          :show-coming-soon="showComingSoon"
        />
      </header>
    </div>
  </div>
</template>

<script>
import Cookies from '@/components/Alerts/Cookies';
import NavBarComponents from './NavBarComponents';

export default {
  name: 'NavBarHome',

  components: {
    NavBarComponents,
    Cookies,
  },

  props: {
    showComingSoon: {
      type: Boolean,
    },
  },

  mounted() {
    // Sticky nav
    // Translated from functions
    const header = document.getElementsByTagName('header')[0];
    window.addEventListener('scroll', () => {
      // let header = document.getElementsByClassName("header")[0];

      if (window.scrollY > 1) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    });
  },
};
</script>
